import React from 'react';
import { useSearchParams } from 'react-router-dom';
import * as api from '../../../api';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import dayjs from 'dayjs';
import FDFicheV2Projet from './FDFicheV2Projet';

const HeaderContainer = styled.div`
    background: white;
    border-bottom: 3px solid black;

    > div {
        margin: auto;
        width : min(1440px,100vw - 40px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 170px;

        > img {
            height: 50%;
        }
    }
`

const LanguageButton = styled.span`
    margin: 0;
    font-size: 21px;
    display: inline-block;
    text-decoration: none;

    &.selected {
        text-decoration: underline;
    }
`

const Label = styled.span`
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
`

function TranslateButton() {

    async function changeLanguage(lang) {
        i18n.changeLanguage(lang);
        dayjs.locale(lang);
        api.SwitchUserLang({lang : lang});
    }

    const {i18n} = useTranslation('common');
    return <div >
        <LanguageButton className={'linkbutton' + (i18n.language === "fr" ? ' selected' : '')} onClick={() => changeLanguage('fr')} style={{marginRight:"20px"}} >Français</LanguageButton>
        <LanguageButton className={'linkbutton' + (i18n.language === "en" ? ' selected' : '')} onClick={() => changeLanguage('en')} >English</LanguageButton>
    </div>
}

const Header = () => {
    return (
        <HeaderContainer>
            <div>
                <img src='/img/lfd100.png' alt="logo" />
                <TranslateButton/>
            </div>
        </HeaderContainer>
    )
}

const FDFicheV2ProjetPage = () => {

    const [searchparams] = useSearchParams();
    const [user, setUser] = React.useState(null);
    const [selectedProject, setSelectedProject] = React.useState(null);

    //get user data
    React.useEffect(() => {
        api.GetAllUserData({email:searchparams.get("email")}).then((response) => {
            // console.log("found user")
            // console.log(response.data)
            setUser(response.data)
        }).catch((error) => {
            console.log(error);
        });
    }, [])

    // get participation
    React.useEffect(() => {
        if(!user || user.participation) return;
        api.getUserParticipations({userid : user.user._id}).then((response) => {
            const _participation = response.data.find((_participation) => _participation._id === searchparams.get("pid"));
            // console.log("found participation :")
            // console.log(_participation)
            _participation.data = _participation.data || {}
            setUser({...user,participation:_participation});
            if(_participation.data.projets && _participation.data.projets.length > 0) {
                const selectedProject = _participation.data.projets.find((_project) => _project._id === searchparams.get("projid"));
                if(selectedProject){
                    setSelectedProject(selectedProject);
                }
            }
        }).catch((error) => {
            console.log(error);
        });
    },[user]);

    return (
        <div>
            <Header/>
            {user && user.participation && selectedProject &&
                <FDFicheV2Projet
                    selectedProject = { selectedProject }
                />
            }
        </div>
    );
};

export default FDFicheV2ProjetPage;